<template>
  <div
    v-if="open"
    class="terms-modal"
    role="presentation"
    @click.self="close"
  >
    <div
      class="terms-modal__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="terms-modal-title"
    >
      <div class="terms-modal__header">
        <h2 id="terms-modal-title" class="terms-modal__title">Terms & Conditions</h2>
        <button
          type="button"
          class="terms-modal__close"
          aria-label="Close"
          @click="close"
        >
          &#10005;
        </button>
      </div>
      <div
        class="terms-modal__body"
        v-html="preparedHtml"
        @click="onContentClick"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsConditionsModal',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    html: {
      type: String,
      default: '',
    },
  },
  computed: {
    preparedHtml() {
      const source = this.html || '';
      const document = new DOMParser().parseFromString(`<div>${source}</div>`, 'text/html');
      document.querySelectorAll('a').forEach((anchor) => {
        anchor.setAttribute('target', '_blank');
        anchor.setAttribute('rel', 'noopener noreferrer');
      });

      return document.body.innerHTML;
    },
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        document.addEventListener('keydown', this.onKeydown);
        return;
      }
      document.removeEventListener('keydown', this.onKeydown);
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    },
    onContentClick(event) {
      const link = event.target.closest('a');
      if (!link) {
        return;
      }

      const href = link.getAttribute('href');
      if (!href || !/^(https?:|mailto:)/i.test(href.trim())) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      window.open(href, '_blank', 'noopener,noreferrer');
    },
  },
}
</script>

<style lang="scss" scoped>
.terms-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.28);
  padding: 24px;
}

.terms-modal__dialog {
  width: min(560px, 100%);
  max-height: min(70vh, 560px);
  display: flex;
  flex-direction: column;
  background: #f4f4f4;
  border-radius: 4px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
  padding: 22px 24px 28px;
}

.terms-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.terms-modal__title {
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 700;
  color: #1f2933;
}

.terms-modal__close {
  border: 0;
  background: transparent;
  color: #111;
  font-size: 18px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}

.terms-modal__body {
  overflow-y: auto;
  min-height: 160px;
  max-height: 380px;
  padding-right: 12px;
  color: #333;
  font-size: 14px;
  line-height: 1.5;

  ::v-deep a {
    color: #1d4ed8;
    text-decoration: underline;
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #d5d5d5;
  }

  &::-webkit-scrollbar-thumb {
    background: #1f1f1f;
  }
}
</style>
